/**
 * Cờ tính năng đọc từ biến môi trường `VITE_*` (Vite inline lúc build) —
 * tương ứng `EXPO_PUBLIC_FEATURE_AI` ở apps/mobile/src/featureFlags.ts.
 */

/// Giá trị coi là TẮT. Ngoài danh sách này (kể cả không khai báo) đều là BẬT.
const OFF_VALUES = ['false', '0'];

export function isAiFeatureEnabled(): boolean {
  const raw = import.meta.env.VITE_FEATURE_AI;
  if (raw == null) return true;
  return !OFF_VALUES.includes(raw.trim().toLowerCase());
}

/** Mục Cộng đồng + Chat — tương ứng `EXPO_PUBLIC_FEATURE_SOCIAL` của mobile. */
export function isSocialFeatureEnabled(): boolean {
  const raw = import.meta.env.VITE_FEATURE_SOCIAL;
  if (raw == null) return true;
  return !OFF_VALUES.includes(raw.trim().toLowerCase());
}

/** Cộng đồng/Chat chạy bằng dữ liệu giả trong src/mock/social.ts — chỉ khi đặt đúng "true". */
export function isSocialMockEnabled(): boolean {
  return import.meta.env.VITE_SOCIAL_MOCK?.trim().toLowerCase() === 'true';
}
